import { Fragment, useRef } from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import { postRequest } from '../../../utils/axiosRequests';
import { Tooltip } from 'react-tooltip';

const InstructionTypeHead = ({
  index,
  instructions,
  item,
  detailIndex,
  setInstructions,
  fieldUpdateWithValue,
}) => {
  let typeaheadRef = useRef(null);

  const handleInstructions = (selectedOption) => {
    const selectedData = selectedOption[0].name;
    if (instructions.some((instruction) => instruction.name === selectedData)) {
      if (
        !item?.itemDetails[detailIndex]?.instructions.some(
          (instruction) => instruction.name === selectedData,
        )
      ) {
        fieldUpdateWithValue('instructions', selectedData);
      }
    } else {
      postRequest('instructions', { name: selectedData })
        .then((data) => {
          fieldUpdateWithValue('instructions', selectedData);
          setInstructions([...instructions, data]);
        })
        .catch((error) => {
          console.log(error);
        });
    }
    typeaheadRef?.current?.clear();
  };

  return (
    <div className="typeahead-wrapper">
      <Typeahead
        style={{ position: 'static', width: '90%' }}
        allowNew
        labelKey="name"
        key={index}
        ref={typeaheadRef}
        newSelectionPrefix="Click to add new: "
        options={instructions}
        placeholder="Search / Add medicine remarks here ..."
        onChange={handleInstructions}
        size="sm"
        dropup
        renderMenuItemChildren={(option, props) => (
          <Fragment>
            <span
              className="my-anchor-element"
              data-tooltip-content={option.name}
            >
              {option.name}
            </span>
          </Fragment>
        )}
      />
      <Tooltip
        style={{ zIndex: 99999999 }}
        anchorSelect=".my-anchor-element"
        place="bottom-start"
      />
    </div>
  );
};

export default InstructionTypeHead;
